// steps/StepSmsExplanation.jsx
export default function StepSmsExplanation() {
  return (
    <span>
      Antes de começar, precisamos compartilhar uma informação importante.
      <br />
      Em nossa plataforma, os envios de SMS são realizados por meio de um
      <strong style={{ color: "#8142FC" }}>
        {" "}
        número curto compartilhado{" "}
      </strong>
      .
      <br />
      <hr style={{ margin: "10px 0", border: "0.1px solid #F9F9F9" }} />
      Um número curto é um código menor que um número de telefone convencional,
      utilizado para o envio de mensagens em larga escala.
      <hr style={{ margin: "10px 0", border: "0.1px solid #F9F9F9" }} />
      O termo compartilhado significa que esse mesmo número pode ser utilizado
      por diferentes empresas, reduzindo custos e facilitando a operação.
    </span>
  );
}
